import { store } from '../../Store';
import {getAllDemoData,submitDemoPaper} from './action'

const action = {
    getAllDemoData: (item) => store.dispatch(getAllDemoData(item)),
    submitDemoPaper : (item) => store.dispatch(submitDemoPaper(item)),
}
export default action